import React from 'react'
import SbEditable from "storyblok-react"
import RichText from 'src/utils/RichText'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import Logo from "./Logo"

const SplitWithGridOnRight = ({blok}) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="max-w-6xl mx-auto px-6 my-32 lg:my-56">
                    <div className="flex lg:flex-row flex-col justify-center items-center lg:gap-24 gap-12">
                        <div className="flex flex-col justify-center lg:items-start items-center gap-2 lg:w-1/2 w-full">
                            <Label className="text-lightblue-300" p={true}>{blok.label}</Label>
                            <Heading size="h2" className="lg:text-left text-center mt-2 text-darkblue brightgreenBold">
                                <RichText>{blok.title}</RichText>
                            </Heading>
                            <div className="text-darkblue-700 prose mt-2 lg:text-left text-center">
                                <RichText>{blok.description}</RichText>
                            </div>
                            <Button
                                to={blok.button_target.cached_url}
                                before={blok.button_text}
                                className={`bg-darkblue hover:bg-darkbluehover lg:mt-10 mt-6 before:content-[attr(before)]`}
                            >
                                {blok.button_text}
                            </Button>
                        </div>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:w-1/2 w-full">
                            {blok.logos?.map(logo => <Logo {...logo}/>)}
                        </div>
                    </div>
                </div>
            </div>
      </SbEditable>
    )
  };

export default SplitWithGridOnRight;
  